<template>
  <div>
    <div class="call-indicator">
      <!-- <v-icon class="call-phone">mdi-phone</v-icon> -->
      <v-icon class="" v-if="!call.isInbound">mdi-phone-outgoing</v-icon>
      <v-icon
        class=""
        v-else-if="
          call.isInbound &&
            call.childId == null &&
            call.recordingExternalId != null &&
            call.recordingDurationSeconds > 0
        "
        >mdi-voicemail</v-icon
      >
      <v-icon class="" v-else-if="call.isInbound && call.childId == null"
        >mdi-phone-missed</v-icon
      >
      <v-icon class="" v-else-if="call.isInbound && call.childId != null"
        >mdi-phone-incoming</v-icon
      >
      <v-icon class="hide-icon" v-else>mdi-phone-incoming</v-icon>
    </div>
    <v-list-item-content class="pr-2">
      <v-list-item-title>
        {{ callCustomerName(call) }}
        <v-list-item-action-text
          class="float-right"
          v-text="callDate(call)"
        ></v-list-item-action-text>
      </v-list-item-title>
      <v-list-item-subtitle>
        <span style="height: 19px">{{ callCustomerPhoneNumber(call) }}</span>
        <span class="float-right">
          {{
            call.durationSeconds > 0
              ? callRecordingTiming(call.durationSeconds)
              : "00:00"
          }}
        </span>
      </v-list-item-subtitle>
    </v-list-item-content>
    <v-list-item-subtitle
      v-if="
        call.recordingDurationSeconds > 0 &&
          call.recordingUploadComplete == true
      "
    >
      <!-- <audio
        controls
        :id="recordingId(call)"
        :src="recordingUrl(call)"
        @play="setVMStatus('play')"
        @pause="setVMStatus('pause')"
        @ended="setVMStatus('ended')"
        class="recording-controls"
      ></audio> -->
      <CallAudioPlayer
        :callAudioId="recordingId(call)"
        :accountExternalId="accountExternalId"
        :audioPath="recordingPath(call)"
        :setPlayStatusFunction="setVMStatus"
      ></CallAudioPlayer>
    </v-list-item-subtitle>
    <v-sheet v-if="call.transcription != null">
      <v-list-item-subtitle class="body-2">
        Transcription:
      </v-list-item-subtitle>
      <v-list-item-content class="body-2">
        {{ call.transcription }}
      </v-list-item-content>
    </v-sheet>
  </div>
</template>

<script>
// import dateRelative from "../../../helpers/dateRelative";
import { format } from "date-fns";
import CallAudioPlayer from "../../calls/CallAudioPlayer.vue";

export default {
  name: "CallContentBubble",
  components: {
    CallAudioPlayer
  },
  props: {
    historyItem: Object,
    customerName: String
  },
  data: function() {
    return {
      showActions: 0,
      callVMStatus: "new",
      showVMControls: false,
      callVmId: ""
    };
  },
  computed: {
    accountExternalId() {
      return this.$store.getters["entities/accounts/query"]().first()
        .externalId;
    },
    call() {
      return this.historyItem;
    }
  },
  created() {},
  watch: {},
  methods: {
    formattedDateTime(number) {
      return format(new Date(number), "E h:mm a, M/d/y");
    },
    callDate(call) {
      return this.formattedDateTime(call.startTime);
    },
    callCustomerName(call) {
      const customer = call.customerLookup;
      return customer
        ? customer.name
        : this.customerName
        ? this.customerName
        : "Unknown";
    },
    callCustomerPhoneNumber(call) {
      let phoneNumber = "";
      if (call.isInbound && call.fromPhone) {
        phoneNumber =
          "(" +
          call.fromPhone.substr(2, 3) +
          ") " +
          +call.fromPhone.substr(5, 3) +
          "-" +
          call.fromPhone.substr(8, 4);
      } else if (call.toPhone) {
        phoneNumber =
          "(" +
          call.toPhone.substr(2, 3) +
          ") " +
          +call.toPhone.substr(5, 3) +
          "-" +
          call.toPhone.substr(8, 4);
      } else {
        phoneNumber = "Restricted";
      }
      return phoneNumber;
    },
    callRecordingTiming(duration) {
      let secondTiming =
        duration % 60 < 10 ? "0" + (duration % 60) : duration % 60;
      let minuteTiming =
        Math.floor(duration / 60) < 10
          ? "0" + Math.floor(duration / 60)
          : Math.floor(duration / 60);
      return minuteTiming + ":" + secondTiming;
    },
    recordingId(call) {
      return "recording-" + call.recordingExternalId;
    },
    recordingPath(call) {
      return `call-recording/${call.recordingExternalId}.mp3`;
    },
    clickCallRecording(call) {
      let thisCall = call;
      if (this.callVMStatus == "play") {
        this.callVmId = call.recordingExternalId;
        this.callVMStatus = "pause";
        let vueThis = this;
        this.$nextTick(function() {
          document.getElementById(vueThis.recordingId(thisCall)).pause();
        });
      } else {
        this.callVmId = call.recordingExternalId;
        this.callVMStatus = "play";
        let vueThis = this;
        this.$nextTick(function() {
          document.getElementById(vueThis.recordingId(thisCall)).play();
        });
      }
    },
    setVMStatus(status) {
      this.callVMStatus = status;
    },
    async clickCall(call) {
      if (call) {
        await this.$store.dispatch("entities/calls/clickCall", {
          call: call
        });
      }
    },
    async snoozeMessage(call) {
      if (call.customerId) {
        await this.$store.dispatch(
          "entities/messageLookups/clickMessageLookup",
          {
            call: call,
            action: "messageSnooze",
            actionDate: new Date()
          }
        );
      }
    },
    async archiveMessage(call) {
      if (call.customerId) {
        await this.$store.dispatch(
          "entities/messageLookups/clickMessageLookup",
          {
            call: call,
            action: "messageArchive"
          }
        );
      }
    },
    async unArchiveMessage(call) {
      if (call.customerId) {
        await this.$store.dispatch(
          "entities/messageLookups/clickMessageLookup",
          {
            call: call,
            action: "messageUnarchive"
          }
        );
      }
    },
    filterList(type) {
      this.listFilter = type;
    }
  }
};
</script>

<style scoped lang="stylus">
.call-indicator, .call-phone {
  margin: auto 8px auto 0;
}
.call-phone {
  margin: auto 8px auto 0;

}
</style>
